import {Map} from 'immutable';

import moment from 'moment-timezone';

import {GET_FREEBET} from 'sagas/actions';

import * as Signin from 'actions/auth/SigninAction';
import * as LoadAuth from 'actions/auth/loadAuthAction';
import * as Freebet from 'actions/Freebet';

export default function freebetReducer(freebet, action) {
    switch (action.type) {
        case Freebet.GET_FREEBET:
        case Freebet.FAILURE_GET_FREEBET:
        case GET_FREEBET.REQUEST:
        case GET_FREEBET.FAILURE:
            return new Map();

        case Signin.SUCCESS_SIGNIN:
        case LoadAuth.SUCCESS_RESTORE:
            return setFreebet(freebet, action.data.Freebet);

        case Freebet.SUCCESS_GET_FREEBET:
        case GET_FREEBET.SUCCESS:
            return setFreebet(freebet, action.data);
    }

    return freebet;
}

function setFreebet(freebet, data) {
    if (data && !data.Error && data.IsPresent) {
        freebet = new Map().set('amount', data.Amount);
        freebet = freebet.set('maxFactorValue', data.MaxFactorValue);
        freebet = freebet.set('startDate', moment.tz(data.StartDate, 'Asia/Bishkek'));
        freebet = freebet.set('promocodeText', data.PromocodeText);
        return freebet.set('expireDate', moment.tz(data.ExpireDate, 'Asia/Bishkek'));
    }

    return freebet;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/freebetReducer.js